import {RuleType} from '../enums';
import {AutomationContextHandlers} from '../modules/FormRules/hooks/useAutomationContextAPI';
import {PriorityIcon} from '@priority-software/priority-style-react';
import {priority} from '@priority-software/priority-proto-api/lib';
import {AlertListItem, AlertMappedItem} from './types';

export type AutomationChoose = {
    value: number | string | boolean;
    label: string;
    description?: string;
    icon?: PriorityIcon;
    disabled?: boolean;
    data?: unknown;
};

export type AutomationChooseOptions = {
    TimeUnits: AutomationChoose[];
    Documents: AutomationChoose[];
    User: AutomationChoose[];
    ExprPredefined: AutomationChoose[];
    ExprFunc: AutomationChoose[];
    Groups: AutomationChoose[];
    MessageTypes: AutomationChoose[];
    MailFields: AutomationChoose[];
    MailUserFields: AutomationChoose[];
    MailTypes: AutomationChoose[];
    Ops: AutomationChoose[];
    CurrrentValues: AutomationChoose[];
    Fields: AutomationChoose[];
    EnglishFields: AutomationChoose[];
    ValidTypes: AutomationChoose[];
    PrivilegeGroups: AutomationChoose[];
    ValueFields: AutomationChoose[];
    DateFields: AutomationChoose[];
    Webhooks: AutomationChoose[];
};

export type AutomationStateType = {
    listResponse: priority.netitems.form.IAlert[];
    automationType: RuleType;
    choosesOptions: AutomationChooseOptions;
    singleRuleOpen: boolean;
    automationRules: Array<AlertListItem> | null;
    filteredRules: Array<AlertListItem> | null;
    isAutomationOpen: boolean;
    openRule: AlertMappedItem | null;
    appliedFilters: Array<AutomationFilter>;
    searchValue: string;
    useBridgeAPI: boolean;
    selectedRuleIndex: number;
    toStatus: string;
    fromStatus: string;
    formName: string | null;
    aiGeneratedRuleId: string | null;
    aiGeneratedRuleQuery: string;
};

export type AutomationFilter = {
    name: string;
    option: {
        value: string | number | boolean;
        label: string;
    };
};

export type AutomationContextType = AutomationStateType & Partial<AutomationContextHandlers>;

export const defaultContext: AutomationContextType = {
    searchValue: '',
    automationType: RuleType.empty,
    choosesOptions: {
        TimeUnits: [],
        Documents: [],
        User: [],
        ExprPredefined: [],
        ExprFunc: [],
        Groups: [],
        MessageTypes: [],
        MailFields: [],
        MailUserFields: [],
        MailTypes: [],
        Ops: [],
        CurrrentValues: [],
        Fields: [],
        EnglishFields: [],
        ValidTypes: [],
        PrivilegeGroups: [],
        ValueFields: [],
        DateFields: [],
        Webhooks: []
    },
    singleRuleOpen: false,
    automationRules: [],
    listResponse: [],
    filteredRules: [],
    isAutomationOpen: false,
    formName: null,
    openRule: null,
    appliedFilters: [],
    useBridgeAPI: false,
    selectedRuleIndex: -1,
    fromStatus: '',
    toStatus: '',
    aiGeneratedRuleQuery: '',
    aiGeneratedRuleId: null
};
